<script lang="ts">
  import { positionModal } from "./actions/positionnode";

  interface Props {
    uri: any;
    alt: any;
  }

  let { uri, alt }: Props = $props();
</script>

<div role="dialog" use:positionModal class="absolute w-fit min-w-[120px] min-h-[120px] bg-white px-4 py-4">
  <img src={uri} {alt} class="block" />
</div>

<style lang="postcss">
  img {
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 90vw;
    max-height: 90vh;
  }
</style>
